import { createBrowserHistory } from 'history'
import {env} from "../utility/GlobalUtils"

export default createBrowserHistory({basename: env('REACT_APP_BASENAME')})
